import React from 'react';

export default function ComingSoon() {
  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#F4F6F8',
        color: '#1C2B3A',
        padding: '2rem',
        textAlign: 'center',
        fontFamily: "'Suisse Intl', 'Inter', sans-serif",
      }}
    >
      <img
        src="/logo-phys.svg"
        alt="Physiology"
        style={{
          width: '180px',
          maxWidth: '60vw',
          height: 'auto',
          marginBottom: '2.5rem',
        }}
      />
      <p
        style={{
          fontFamily: "'Canela', Georgia, serif",
          fontSize: 'clamp(1.25rem, 3vw, 1.75rem)',
          letterSpacing: '0.02em',
          fontWeight: 300,
          margin: 0,
          color: '#4A5E70',
        }}
      >
        Próximamente
      </p>
    </div>
  );
}
